import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps";
import { useTranslation } from "react-i18next";

const CollectionAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label, load = true, disabled = false, infoText, error, helperText }) => {
    const { t } = useTranslation();
    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.collection")}
            url="/autocompleteApi/Collection"
            valueId={valueId}
            load={load}
            onChange={onChange}
            infoText={infoText}
            error={error}
            helperText={helperText}
            disabled={disabled}
        />
    );
};

export default CollectionAutoComplete;
